import createContext from '../utils/createContext';
export var FormContext = createContext({});
export var FormValueContext = createContext({});
export var FormErrorContext = createContext({});
export var FormPlaintextContext = createContext(false);
export default FormContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/Form/FormContext.js
// module id = 405
// module chunks = 35